<script setup>
import { usePage } from "@inertiajs/vue3";
import FormBuilder from "@/Components/FormBuilder.vue";

const {
  props: { siteSettings },
} = usePage();
const { newsletter_content, newsletter_heading, form } = siteSettings;
</script>

<template>
  <div class="sm:py-6 md:py-0 lg:py-2 [&_p]:text-[23px] [&_p]:lg:text-[28px]">
    <h3 class="h1 uppercase">{{ newsletter_heading }}</h3>
    <p>{{ newsletter_content }}</p>
    <div id="footer-newsletter-form">
      <FormBuilder class="max-w-[870px] gap-4" :form="form" />
    </div>
  </div>
</template>

<style lang="postcss">
#footer-newsletter-form form label {
  @apply font-serif font-normal text-brand-dark-blue text-[14px] lg:text-[16px] normal-case !important;
}
#footer-newsletter-form form .leading-none.text-errors {
  @apply text-[14px] lg:text-[16px];
}
</style>
